import api from './api';
import { DeleteReadingsResponse, EnergyReadingsResponse, MeterLogResponse, PvReadingsResponse, TimeFilter } from '../types';

const energyService = {
  getReadings: async (meterId: number, filter: TimeFilter): Promise<EnergyReadingsResponse> => {
    const response = await api.get<EnergyReadingsResponse>(
      `/meters/${meterId}/readings`,
      { params: { filter } }
    );
    return response.data;
  },

  getPvReadings: async (meterId: number, filter: TimeFilter): Promise<PvReadingsResponse> => {
    const response = await api.get<PvReadingsResponse>(
      `/meters/${meterId}/pv`,
      { params: { filter } }
    );
    return response.data;
  },

  getMeterLog: async (meterId: number, limit: number = 50): Promise<MeterLogResponse> => {
    const response = await api.get<MeterLogResponse>(
      `/meters/${meterId}/log`,
      { params: { limit } }
    );
    return response.data;
  },

  /** Admin: löscht alle Messwerte eines Zählers, optional samt Zählerstand. */
  deleteReadings: async (
    meterId: number,
    deleteCurrentReading: boolean
  ): Promise<DeleteReadingsResponse> => {
    const response = await api.delete<DeleteReadingsResponse>(
      `/meters/${meterId}/readings`,
      { params: { deleteCurrentReading } }
    );
    return response.data;
  },
};

export default energyService;
